import DOMPurify from "dompurify";

export default function HtmlRenderer({ html }) {
  const cleanHtml = DOMPurify.sanitize(html);

  return (
    <div
      id="budget-text"
      className="prose"
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
    />
  );
}
